import React from 'react';
import { MicroTrainingsNewslettersList as MicroTrainingsList } from '../../components';

const MicroTrainings = () => {
  return (
    <MicroTrainingsList adminPage="microTrainings" resource="microTraining" />
  );
};

export default MicroTrainings;